
import { currentHelpers } from "../../redirection/current";
import { _showAppLogs } from "../contexts/LogContext";

export const papsInitialState = () => {
  return {}
};

export const rts = {
  handleAmmend_current: 'handleAmmend_current',
  handleHomePageSeen: 'handleHomePageSeen',
  handleUpdate_messagingSupported: 'handleUpdate_messagingSupported',
  handleWaiverSeen: 'handleWaiverSeen',
}

export const papsReducer = (state, action) => {

  const { type, previousPathName } = action

  _showAppLogs.reducerTypes && console.log('✔️ papsReducer', type)

  switch (type) {

    case rts.handleAmmend_current:
      const { current } = action
      console.log('🟢🟢🔄 handleAmmend_current', action)
      return {
        ...current,
        _settingsDocName: current.settingsDocName,
        previousPathName: previousPathName,
        updated: true
      }

    case rts.handleHomePageSeen:
      const item_hp = action.eventKey ? 'homePageSeen-' + action.eventKey : 'homePageSeen'
      currentHelpers.storageItem_set(item_hp, true);
      return { state, homePageSeen: true }

    case rts.handleWaiverSeen:
      const item_w = action.eventKey ? 'waiverSeen-' + action.eventKey : 'waiverSeen'
      currentHelpers.storageItem_set(item_w, true);
      return { state, waiverSeen: true }

    case rts.handleUpdate_messagingSupported:
      return { ...state, messagingSupported: action.messagingSupported }

    default:
      return state
  }
}

export const papsHandlers = (dispatch) => {
  return {
    handleAmmend_current: (current, previousPathName, _params) => { dispatch({ type: rts.handleAmmend_current, dispatch, current, previousPathName }) },
    handleHomePageSeen: (eventKey) => { dispatch({ type: rts.handleHomePageSeen, dispatch, eventKey }) },
    handleWaiverSeen: (eventKey) => { dispatch({ type: rts.handleWaiverSeen, dispatch, eventKey }) },
    handleUpdate_messagingSupported: (messagingSupported) => { dispatch({ type: rts.handleUpdate_messagingSupported, dispatch, messagingSupported }) },
  }
} 